import { Tag } from "antd";
import "./StatusBadge.css";

/**
 * StatusBadge — Consistent status display across all modules.
 *
 * Usage:
 *   <StatusBadge status="active" />
 *   <StatusBadge status="pending" />
 *   <StatusBadge status="approved" />
 *   <StatusBadge status="rejected" />
 *   <StatusBadge status="hold" />
 *   <StatusBadge status="inactive" />
 */

const STATUS_CONFIG = {
  active:     { color: "green",   label: "Active" },
  inactive:   { color: "default", label: "Inactive" },
  deleted:    { color: "red",     label: "Deleted" },
  pending:    { color: "gold",    label: "Pending" },
  approved:   { color: "green",   label: "Approved" },
  rejected:   { color: "red",     label: "Rejected" },
  hold:       { color: "orange",  label: "Hold" },
  suspended:  { color: "red",     label: "Suspended" },
  processing: { color: "blue",    label: "Processing" },
  completed:  { color: "green",   label: "Completed" },
  cancelled:  { color: "default", label: "Cancelled" },
  transferred:{ color: "green",   label: "Transferred" },
  inProgress: { color: "blue",    label: "In Progress" },
  paid:       { color: "green",   label: "Paid" },
  failed:     { color: "red",     label: "Failed" },
};

export default function StatusBadge({ status, label }) {
  const config = STATUS_CONFIG[status] || {
    color: "default",
    label: status || "Unknown",
  };

  return (
    <Tag
      color={config.color}
      className="status-badge"
    >
      {label || config.label}
    </Tag>
  );
}
